module.exports = __webpack_public_path__ + "img/hat1_6s_4.f68a2e6a.svg";